<template>
    <div class="panel panel-default">
        <div class="panel-heading">
            <h3>Поиск супервайзеров (салонов)</h3>
        </div>

        <panel-search @search="search" placeholder="Введите фио или наименование салона, телефон или почту для поиска"></panel-search>

        <table class="table table-striped">
            <thead>
            <tr>
                <th>ФИО</th>
                <th>Салон</th>
                <th>Телефон</th>
                <th>E-mail</th>
                <th>Сегодня</th>
                <th>Неделя</th>
                <th>Месяц</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="supervisor in supervisors">
                <td>
                    <a :href="`/supervisors/${supervisor.id}`">{{ supervisor.full_name }}</a>
                </td>
                <td>
                    <a :href="`/salons/${supervisor.salon_id}/edit`">{{supervisor.salon.name}}</a>
                </td>
                <td>{{supervisor.phone}}</td>
                <td>{{supervisor.email}}</td>
                <td>{{supervisor.count_inspection}}</td>
                <td>{{supervisor.count_inspection_week}}</td>
                <td>{{supervisor.count_inspection_month}}</td>
            </tr>
            </tbody>
        </table>

        <button class="load-more" v-if="next_page_url" @click="loadNextPage">Еще</button>
    </div>
</template>
<script>
    import axios from 'axios'
    import _ from 'lodash'

    export default {
        data() {
            return {
                q: '',
                activated: true,
                loading_next_page: null,
                next_page_url: null,
            }
        },
        props: ['salon_id'],
        asyncComputed: {
            supervisors() {
                return axios
                    .get('/api/supervisors', {
                        params: {
                            q: this.q,
                            activated: 1,
                            search_fields: ['name','last_name','middle_name','salon.name','email','phone']
                        }
                    })
                    .then(({data}) => {
                        this.next_page_url = data.next_page_url
                        return data.data
                    })
            },
        },
        methods: {
            search(q) {
                this.q = q
            },
            loadNextPage() {
                if (!this.loading_next_page) {
                    this.loading_next_page = axios
                        .get(this.next_page_url)
                        .then(({data}) => {
                            this.next_page_url = data.next_page_url
                            this.supervisors = this.supervisors.concat(data.data)
                        })
                        .finally(() => this.loading_next_page = null)
                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// ShowSupervisorAdmin.vue?1b01723e